module.exports = __webpack_public_path__ + "img/nothing.d24cb2df.png";